import { UserDetailsModel } from 'src/app/user/add-user/user.details.model';

export class UserModel{
    secUsrId:number;
    defaultSecProId:number;
    staRecCode:string;
    secUsrDesc:string;
    secUsrLogin:string;
    secUsrPwd:string;
    secUsrCnfrmPwd:string;
    tuSecUserDetail:UserDetailsModel=new UserDetailsModel();
}